import React from "react";
import styles from "./index.module.scss";
import Swiper from "../Swiper";

export default function Index(props) {
  const { style, videoList, ambulance, info, selectedItem={}, handleSelectVideo } = props;
  return (
    <div className={styles.vedio_container} style={style}>
      <div className={styles.rightVedio_container}>
        <Swiper videoList={videoList} ambulance={ambulance} handleSelectVideo ={handleSelectVideo} selectedItem={selectedItem} />
      </div>
      <div className={styles.leftVedio_container}>
        <div className={styles.title_container}>
          <div className={styles.title}>{info.title}</div>
          <div className={styles.second_title}>{info.second_title}</div>
        </div>
        <div className={styles.vedio_content}>
          <video src={ambulance + selectedItem.path} controls poster={ambulance + selectedItem.photo}>
            Your browser does not support the video tag.
          </video>
        </div>
        <div className={styles.vedio_desc}>
         {selectedItem.tips}
        </div>
      </div>
    </div>
  );
}
